export default __webpack_public_path__ + "assets/audio/ssml/p-s.c58a012859f6458701d7362ad980af3a.mp3";